/* eslint no-undef: 0 */
const beautyKit2Loader = async () => {
	return new Promise((resolve, reject) => {
		createMyModule().then((BK2Module) => {
			console.log('[BK2] BeautyKit 2 Module Available');
			resolve(BK2Module);
		}).catch(reject);
	});
};

function getImageCapture(track) {
	return new ImageCapture(track);
}

export { beautyKit2Loader, getImageCapture };
